__turbopack_context__.v({
  "addressBlock": "congratulation-module-scss-module__SWrtOG__addressBlock",
  "bidAuction": "congratulation-module-scss-module__SWrtOG__bidAuction",
  "bidAuctionBottom": "congratulation-module-scss-module__SWrtOG__bidAuctionBottom",
  "bidAuctionTitle": "congratulation-module-scss-module__SWrtOG__bidAuctionTitle",
  "bidMainBox": "congratulation-module-scss-module__SWrtOG__bidMainBox",
  "bidSecLt": "congratulation-module-scss-module__SWrtOG__bidSecLt",
  "bidSecRt": "congratulation-module-scss-module__SWrtOG__bidSecRt",
  "bigSecTop": "congratulation-module-scss-module__SWrtOG__bigSecTop",
  "black-bt": "congratulation-module-scss-module__SWrtOG__black-bt",
  "btnCustom": "congratulation-module-scss-module__SWrtOG__btnCustom",
  "congTop": "congratulation-module-scss-module__SWrtOG__congTop",
  "cricleBox": "congratulation-module-scss-module__SWrtOG__cricleBox",
  "guestUser": "congratulation-module-scss-module__SWrtOG__guestUser",
  "headingText": "congratulation-module-scss-module__SWrtOG__headingText",
  "incShippingText": "congratulation-module-scss-module__SWrtOG__incShippingText",
  "mgTop15": "congratulation-module-scss-module__SWrtOG__mgTop15",
  "pccPercentsWrapper": "congratulation-module-scss-module__SWrtOG__pccPercentsWrapper",
  "ppcPercents": "congratulation-module-scss-module__SWrtOG__ppcPercents",
  "ppcProgress": "congratulation-module-scss-module__SWrtOG__ppcProgress",
  "ppcProgressFill": "congratulation-module-scss-module__SWrtOG__ppcProgressFill",
  "ppcProgressFillGt": "congratulation-module-scss-module__SWrtOG__ppcProgressFillGt",
  "ppcProgressGt": "congratulation-module-scss-module__SWrtOG__ppcProgressGt",
  "progressPieChart": "congratulation-module-scss-module__SWrtOG__progressPieChart",
  "progressPieChartGt": "congratulation-module-scss-module__SWrtOG__progressPieChartGt",
  "row": "congratulation-module-scss-module__SWrtOG__row",
  "sizeBox": "congratulation-module-scss-module__SWrtOG__sizeBox",
  "socialSecRt": "congratulation-module-scss-module__SWrtOG__socialSecRt",
  "user": "congratulation-module-scss-module__SWrtOG__user",
  "variantBox": "congratulation-module-scss-module__SWrtOG__variantBox",
});
